<script lang="ts">
	import type { HTMLInputAttributes } from "svelte/elements";
	import { Locale, type LocalizedString } from "@core/schema/Locale.js";
	import { emailPattern } from "@core/utils/email.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { ...rest }: HTMLInputAttributes = $props();
	const { tenant } = getGlobalTemplateProps();

	const type = $derived(rest.type ?? "text");
	const customPattern: Partial<Record<NonNullable<HTMLInputAttributes["type"]>, string>> = {
		email: emailPattern,
	};
	const pattern = $derived(rest.pattern ?? customPattern[type]);

	const customValidationMessage: Partial<Record<NonNullable<HTMLInputAttributes["type"]>, LocalizedString>> = {
		email: {
			[Locale.cs]: "E-mailová adresa",
		},
		url: {
			[Locale.cs]: "URL adresa (včetně https://)",
		},
	};

	function validate({ currentTarget }: Event & { currentTarget: EventTarget & HTMLInputElement }): void {
		currentTarget.setCustomValidity("");

		if (currentTarget.validity.valid) {
			currentTarget.setCustomValidity("");
		} else {
			const customMessage = customValidationMessage[type]?.[tenant.locale];
			if (customMessage) {
				currentTarget.setCustomValidity(customMessage);
			}
		}
	}
</script>

<input
	{...rest}
	class={[
		["radio", "checkbox"].includes(type)
			? "size-5 appearance-none rounded border-2 border-ivory-500 bg-white cursor-pointer transition-all duration-300 checked:border-hazelnut-300 checked:bg-hazelnut-300 relative after:content-[''] after:absolute after:inset-0 after:bg-[url('data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22white%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M12.207%204.793a1%201%200%20010%201.414l-5%205a1%201%200%2001-1.414%200l-2-2a1%201%200%20011.414-1.414L6.5%209.086l4.293-4.293a1%201%200%20011.414%200z%22%2F%3E%3C%2Fsvg%3E')] after:opacity-0 checked:after:opacity-100 after:transition-opacity after:duration-300 focus:outline-hazelnut-200 focus:outline focus:outline-2 focus:outline-offset-1 [&:user-invalid]:border-copper-300"
			: "min-w-0 rounded-lg border bg-white/80 shadow-sm border-ivory-500 [&:user-invalid]:border-copper-300 transition-[outline,text,border] duration-300 focus:border-hazelnut-200 focus:bg-white focus:[&:user-invalid]:outline-copper-300 outline-transparent outline-1 outline outline-offset-1 p-3 placeholder:text-midnight/40 min-h-[3.125rem]",
		rest.class,
	]}
	{pattern}
	oninput={(event: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
		validate(event);
		rest.oninput?.(event);
	}}
	oninvalid={(event: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
		event.preventDefault();
		validate(event);
		rest.oninvalid?.(event);
	}}
/>
